import getUtmValuesFromUrl from '../services/telemetry/utm';

export interface IAffliateConfig {
    goToURI: string;
    affiliateURI: string;
}

const appendValueToUrl = (url: URL, param: string, value: string): URL => {
    if (!param || !value || !param.length || !value.length) return url;
    const updatedUrl = new URL(url.toString());
    updatedUrl.searchParams.append(param, value);
    return updatedUrl;
};

export const createUtmValueForSubIdParameter = (): string => {
    const utmValues = getUtmValuesFromUrl() as Object | null;
    let subId3Values: string | null = '';
    if (utmValues !== null) {
        subId3Values = Object.keys(utmValues).map((k) => {
            if (Object.prototype.hasOwnProperty.call(utmValues, k)) {
                // @ts-ignore
                return `${k}=${utmValues[k] as string}`;
            }
            return null;
        }).filter(v => v !== null)
            .reduce((pv, cv) => {
                if (cv && cv.length) {
                    return (pv && pv.length) ? `${pv}&${cv}` : cv;
                }
                return pv;
            }, '');

        // Remove extra equals sign
        if (subId3Values && subId3Values.length && subId3Values[subId3Values.length - 1] === '=') {
            subId3Values = subId3Values.substring(0, subId3Values.length - 1);
        }

        if (!subId3Values) {
            subId3Values = '';
        }
    }
    return subId3Values;
};

export const createGoToUriWithTrackingParameters = (goToURI: string, subId1 = '', subId2 = '', subId3 = '', sharedId = '', veh = '', sourceId = ''): string => {
    let updatedGoToUrl = new URL(goToURI);
    updatedGoToUrl = appendValueToUrl(updatedGoToUrl, 'subId1', subId1);
    updatedGoToUrl = appendValueToUrl(updatedGoToUrl, 'subId2', subId2);
    updatedGoToUrl = appendValueToUrl(updatedGoToUrl, 'subId3', subId3);
    updatedGoToUrl = appendValueToUrl(updatedGoToUrl, 'sharedID', sharedId);
    updatedGoToUrl = appendValueToUrl(updatedGoToUrl, 'veh', veh);
    updatedGoToUrl = appendValueToUrl(updatedGoToUrl, 'sourceid', sourceId);
    return updatedGoToUrl.toString();
};
